<template>
  <div class="page-my-notification">
    <div class="notification-list"
         v-if="list.length > 0"
    >
      <notification-item v-for="(item, index) in list"
                         :key="index"
                         :item="item"
      ></notification-item>
    </div>
    <empty-page class="empty-page"
                type="message"
                hint="暂无通知消息"
                v-if="showEmptyPage"
    />
  </div>
</template>

<script>
  import { getNotificationList } from '@/services/message';
  import NotificationItem from '@/pages/Notification/components/NotificationItem';
  import EmptyPage from '@/components/EmptyPage';

  export default {
    name: 'MyNotification',
    metaInfo: {
      title: '通知消息',
    },
    components: {
      NotificationItem,
      EmptyPage,
    },
    data() {
      return {
        list: [],
        showEmptyPage: false,
      };
    },
    computed: {
      type() {
        return this.$route.query && this.$route.query.type ? this.$route.query.type : '';
      },
    },
    methods: {
      async getNotificationList() {
        const data = await getNotificationList(this.type);
        this.list = data.list;
        if (data.list.length === 0 && this.list.length === 0) {
          this.showEmptyPage = true;
        }
      },
    },
    created() {
      this.getNotificationList();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-notification {
    background: @color-white;
    padding: @size-base;
    min-height: 100%;
    box-sizing: border-box;
  }
</style>
